import React from 'react'

type Props = {
  title: string
  color: string
}
const TitleDivider = (props: Props) => {
  const { title, color } = props
  return (
    <div className="relative mb-6">
      {/* <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className={`w-full border-t border-${color}`} />
      </div> */}
      <div className="relative flex justify-center">
        <span
          className={`font-heading px-3 font-medium text-${color} text-3xl`}
        >
          {title}
        </span>
      </div>
    </div>
  )
}

export default TitleDivider
